module.exports = __webpack_public_path__ + "static/media/times.d402ce75.svg";